import React from 'react';
import { useSelector } from 'react-redux';

// station-avatar: the current station's picture — a small data-URI (or URL) in
// config.image_url. config survives client redaction, so it arrives on the
// station object. Off a station page (dashboard/gallery) chat.station is {} →
// no config → renders nothing. One <img src> handles a data-URI, an SVG
// data-URI, or a plain URL; onError hides a broken source.
//
// nav-brand-swap: extracted from AuthHeader, which used to render this at the
// END of the nav. The avatar now leads the station header (left) and the aveq
// logo took the nav's trailing slot, so the two live in different components —
// this keeps ONE copy of the key/onError contract below rather than a copy in
// each.
export default function StationPic({ size = 40 }) {
  const chatStation = useSelector((s) => s.chat.station);
  const src = chatStation?.station?.config?.image_url || null;
  const name = chatStation?.station?.name || '';
  if (!src) return null;
  return (
    // key={src}: onError hides the img by imperatively setting display:none,
    // which React does NOT manage — without a per-src key, a station→station nav
    // reconciles the SAME <img> node (updates src but keeps the stale
    // display:none), so a good avatar stays hidden after a broken one. A fresh
    // node per src resets the hide. (MR !573 review.)
    <img key={src}
         src={src} alt={name ? `${name} picture` : 'Station picture'}
         loading="lazy" decoding="async"
         style={{ width: size, height: size, borderRadius: '50%', objectFit: 'cover',
                  flexShrink: 0, boxShadow: '0 1px 3px rgba(0,0,0,0.18)', background: '#fff' }}
         onError={(e) => { e.currentTarget.style.display = 'none'; }} />
  );
}
